module.exports = __webpack_public_path__ + "img/banner-search-db2508f7.png";